import { render, staticRenderFns } from "./RegistrationCode.vue?vue&type=template&id=fc4b5ece&scoped=true&"
import script from "./RegistrationCode.vue?vue&type=script&lang=js&"
export * from "./RegistrationCode.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCode.vue?vue&type=style&index=0&id=fc4b5ece&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b5ece",
  null
  
)

export default component.exports